import { initWCL } from "../../modules/wcl";

initWCL();
